<template>
  <question-base-wrapper
    title="Is the property used for your business purposes?"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed }"
      name="Is Property Business Type"
      :vid="`${stepId}_property-business-type`"
      :rules="{ is_not: { other: null } }"
      slim
    >
      <radio
        v-model="propertyBusinessTypeModel"
        name="is-property-business-use"
        wide
        :error="failed"
        :items="constants.YES_NO"
        :data-test="snakeCase(questionFields.propertyBusinessType)"
      />
    </validation-provider>
    <validation-provider
      v-if="isPropertyBusinessType"
      v-slot="{ errors, failed }"
      name="Property Business Type"
      :vid="`${stepId}_property-business-type`"
      rules="listOptionRequired"
      slim
    >
      <qz-select
        v-model="questionData.propertyBusinessType"
        :items="propertyBusinessTypeItems"
        item-text="text"
        placeholder="Please select usage type"
        :error="failed"
        :error-messages="errors"
        class="mt-4"
        :data-test="`${snakeCase(questionFields.propertyBusinessType)}_other`"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import { omit } from 'lodash';

export default {
  name: 'question-property-business-type',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyBusinessType'],
    };
  },
  computed: {
    propertyBusinessTypeModel: {
      get () {
        if (this.helpers.isNull(this.questionData.propertyBusinessType)) return null;
        return this.constants.HOME_PROPERTY_BUSINESS_TYPE_FAVORITE !== this.questionData.propertyBusinessType;
      },
      set (val) {
        this.questionData.propertyBusinessType = val ? '' : this.constants.HOME_PROPERTY_BUSINESS_TYPE_FAVORITE;
      },
    },

    isPropertyBusinessType () {
      return !this.helpers.isNull(this.propertyBusinessTypeModel) && this.questionData.propertyBusinessType !== this.constants.HOME_PROPERTY_BUSINESS_TYPE_FAVORITE;
    },

    propertyBusinessTypeItems () {
      return this.helpers.createOptions({ source: omit(this.constants.HOME_PROPERTY_BUSINESS_TYPE, this.constants.HOME_PROPERTY_BUSINESS_TYPE_FAVORITE) });
    },
  },
};
</script>
